import React from 'react';
import './timeline-comment-display.scss';

interface CommentDisplayProps {
	comment?: string;
	className?: string;
}

const COMMENT_MAX_LENGTH = 120;

export const TimelineCommentDisplay: React.FC<CommentDisplayProps> = ({ comment, className = '' }) => {
	if (!comment || comment.trim() === '') {
		return null;
	}

	const shouldTruncate = comment.length > COMMENT_MAX_LENGTH;
	const displayText = shouldTruncate ? `${comment.substring(0, COMMENT_MAX_LENGTH).trim()}…` : comment;

	return (
		<div className={`timeline-event-comment ${className}`}>
			<span className="text-muted">{displayText}</span>
		</div>
	);
};
